/**
 * Payment Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentPlatformConfigRequest { 
    platform: PaymentPlatformConfigRequest.PlatformEnum;
    displayName: string;
    description?: string;
    logoUrl?: string;
    partnerName?: string;
    enabled?: boolean;
    configuration?: { [key: string]: object; };
    payType: PaymentPlatformConfigRequest.PayTypeEnum;
    secrets?: { [key: string]: object; };
}
export namespace PaymentPlatformConfigRequest {
    export const PlatformEnum = {
        Momo: 'MOMO',
        Zalopay: 'ZALOPAY',
        Vnpay: 'VNPAY',
        Stripe: 'STRIPE',
        Cod: 'COD',
        None: 'NONE'
    } as const;
    export type PlatformEnum = typeof PlatformEnum[keyof typeof PlatformEnum];
    export const PayTypeEnum = {
        Cash: 'CASH',
        BankTransfer: 'BANK_TRANSFER',
        Card: 'CARD',
        EWallet: 'E_WALLET',
        Cod: 'COD'
    } as const;
    export type PayTypeEnum = typeof PayTypeEnum[keyof typeof PayTypeEnum];
}


